// Angular imports
import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

// Import column types
import { ColumnMap, TemplateCategoryApi } from '../../types';
import { ViewModelLine } from 'src/app/state-management/calculation-state';
import { AppState } from 'src/app/state-management/app-state';
import { Store, select } from '@ngrx/store';
import { BehaviorSubject, Observable, Subject, combineLatest, filter, map, takeUntil } from 'rxjs';
import { selectTemplate, selectTemplateDictionary } from 'src/app/state-management/calculation-selectors';


@Component({
    selector: 'category-row',
    templateUrl: './category-row.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./category-row.component.scss'],
    standalone: false
})
export class CategoryRowComponent implements OnInit {
    private unsubscribe$ = new Subject<void>();

    public category$ = new BehaviorSubject<ViewModelLine | undefined>(undefined);

    @Input() 
    public set category(value: ViewModelLine){
        this.category$.next(value);
    };

    @Input() public columns: ColumnMap;

    // Fields for totals
    public _normTotal: number;
    public _grossNormTotal: number;
    public _netTotal: number;
    public _grossTotal: number;

    constructor(
    ) {
        this.category$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((cat) => this.refresh(cat))
    }

    public ngOnInit() {
    }

    public onDestroy(){
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    /**
     * Refreshes the internal state of the category row. (Totals)
     * @returns void
     */
    public refresh(category: ViewModelLine): void {
        if(!category){
            return;
        }

        const {all: {
            gross,
            net,
            norm,
            unitPrice
        }} = category?.aggregation;
        
        this._normTotal = norm;
        this._grossNormTotal = unitPrice;
        this._netTotal = net;
        this._grossTotal = gross;

    }
}
